import Client from "./Clients/AxiosClient";
const resource = "/api/v1/admin/dashboard";
const transaction = "/api/v1/admin/dashboard/transaction";
const user = "/api/v1/admin/dashboard/user";
const product = "/api/v1/admin/dashboard/product";

export default {
  get() {
    return Client.get(`${resource}`);
  },

  // Transaction Related Endpoints
  getTransactionSummary(params) {
    return Client.get(`${transaction}/summary`, {
      params: {
        start_time: params.start_time || "",
        end_time: params.end_time || "",
      },
    });
  },
  getTransactionStats(params) {
    return Client.get(`${transaction}/chart`, {
      params: {
        period: params.period || "", // decade, tahunan, bulanan
        sub_period: params.sub_period || "", // tahunan, bulanan, harian,quarter
      },
    });
  },
  getTransactionTopOmset(params) {
    return Client.get(`${transaction}/top-omset`, {
      params: {
        start_time: params.start_time || "",
        end_time: params.end_time || "",
      },
    });
  },
  getTransactionTopProducts(params) {
    return Client.get(`${transaction}/top-products`, {
      params: {
        start_time: params.start_time || "",
        end_time: params.end_time || "",
      },
    });
  },

  // User Related Endpoints
  getUserSummary(params) {
    return Client.get(`${user}/summary`, {
      params: {
        start_time: params.start_time || "",
        end_time: params.end_time || "",
      },
    });
  },
  getUsersMonthlyActive(params) {
    return Client.get(`${user}/monthly-active`, {
      params: {
        year: params.year || "",
      },
    });
  },

  // Product Related Endpoints
  getTopProductsSummary(params) {
    return Client.get(`${product}/summary`, {
      params: {
        start_time: params.start_time || "",
        end_time: params.end_time || "",
      },
    });
  },
  getPaketTryoutList(params) {
    return Client.get(`${product}/paket-tryout`, {
      params: {
        page: params.page || 1,
        page_size: params.page_size || 10,
        order_by: params.order_by || "updated_at",
        sort_dir: params.sort_dir || "asc",
        search: params.search || "",
      },
    });
  },
  getPaketTryoutUsers(id, params) {
    return Client.get(`${product}/paket-tryout/${id}`, {
      params: {
        page: params.page || 1,
        page_size: params.page_size || 10,
        order_by: params.order_by || "updated_at",
        sort_dir: params.sort_dir || "asc",
        search: params.search || "",
      },
    });
  },
  resetPengerjaan(id) {
    return Client.delete(`/api/v1/admin/pengerjaan/tryout/reset/${id}`);
  },
};
